require('./bootstrap');
import IMask from 'imask'
import * as bootstrap from 'bootstrap';
import Datepicker from 'vanillajs-datepicker/Datepicker';
import pt from 'vanillajs-datepicker/locales/pt';
import Toastr from 'toastr';
import Tselect from 'tom-select'
import Swal from 'sweetalert2';
import * as Validator from 'validatorjs';
import { Grid, h, } from "gridjs";
import { RowSelection } from "gridjs/plugins/selection";
import Viewer from 'viewerjs';

try {
    const setStarForRequiredFields = () => {
        const allRequiredFields = document.querySelectorAll(".isRequired, .isRequiredStep1, .isRequiredStep2, .isRequiredStep3, .isRequiredStep4");
        for (const field of allRequiredFields) {
            const span = create_element({ tag: 'span', estilos: 'font-size:7px;', classes: 'text-danger' });
            const star = create_element({ tag: 'i', classes: 'bi bi-asterisk' });
            span.append(star);

            const grandParentElement = field.parentElement.parentElement;
            const label = grandParentElement.querySelector('label');
            if (!!label && !label.querySelector('i.bi.bi-asterisk')) {
                label.append(span);
            }
        }
    }

    setStarForRequiredFields();

    // toatr config
    Toastr.options = {
        "progressBar": true,
        "positionClass": "toast-bottom-right",
        "preventDuplicates": false,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut",
    }

    const invalidClass = "is-invalid";

    function generateMask(classe, mask) {
        const input = document.querySelectorAll(`.${classe}`),
            styleMask = {
                mask,
                overwrite: true
            };
        if (classe === 'phone') {
            styleMask['lazy'] = false;
            styleMask['placeholderChar'] = " ";
            styleMask['placeholder'] = {
                show: 'always'
            }
        }
        for (const el of input) {
            IMask(el, styleMask);
            if (classe === 'phone')
                el.onkeyup = ({ target, key }) => {
                    if (target.value.replace(/(\s+)/g, '').length === 6 && key === '9')
                        el.value = target.value.replace(/(\s+)(.+)/g, '') + ' 9 9';
                }
        }
    }

    // mascara para cpf
    generateMask('cpf', '000.000.000-00')

    // mascara para cnpj
    generateMask('cnpj', '00.000.000/0000-00')

    // mascara para numero do contrato plano
    generateMask('contract_plan', '000.000/00-0')

    // mascara para numero do cartao
    generateMask('cardnumber', '0000 0000 0000 0000')

    // mascara para cns
    generateMask('cnsnumber', '000 0000 0000 0000')

    // mascara para numero do cartao
    generateMask('expirationdate', '00/00')

    // mascara para cep
    generateMask('cep', '00000-000')

    // mascara para telefone
    generateMask('phone', '{(}00{)} {9} 0000-0000')

    // mascara para telefone fixo
    generateMask('fixed-phone', '(00) 0000-0000')

    // mascara para data
    generateMask('date', '00/00/0000')

    Object.assign(Datepicker.locales, pt);
    // transfome em datepickers
    const RunDates = (exists = 0) => {
        try {
            const elem = document.querySelectorAll('.date');
            [...elem].map(Elem => {
                if (exists) {
                    Elem.datepicker.destroy();
                }
                new Datepicker(Elem, {
                    'format': 'dd/mm/yyyy', 'language': 'pt', 'todayHighlight': true
                });
            })
            const mesAno = document.querySelectorAll('.mesAno');
            [...mesAno].map(Elem => {
                if (exists) {
                    Elem.datepicker.destroy();
                }
                
                // Configurações base
                const config = {
                    'format': 'mm/yyyy', 
                    'language': 'pt', 
                    'todayHighlight': true, 
                    'pickLevel': 1
                };
                
                // Adicionar restrição de data para o campo firstPay
                if (Elem.id === 'firstPay') {
                    const currentDate = new Date();
                    const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 2, 0); // Último dia do próximo mês
                    
                    config.startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // Primeiro dia do mês atual
                    config.endDate = nextMonth; // Limita até o final do próximo mês
                    
                    // Adicionar validação extra no evento changeDate
                    Elem.addEventListener('changeDate', function(e) {
                        const selectedDate = e.detail.date;
                        const selectedMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
                        const currentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
                        const oneMonthAhead = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
                        
                        if (selectedMonth < currentMonth || selectedMonth > oneMonthAhead) {
                            addRequiredClass(Elem, invalidClass);
                            Toastr.error('Selecione o mês atual ou o próximo mês.');
                            Elem.value = '';
                        } else {
                            removeRequiredClass(Elem, invalidClass);
                        }
                    });
                }
                
                new Datepicker(Elem, config);
            });
            const apenasAno = document.querySelectorAll('.apenasAno');
            [...apenasAno].map(Elem => {
                if (exists) {
                    Elem.datepicker.destroy();
                }
                new Datepicker(Elem, {
                    'format': 'yyyy', 'language': 'pt', 'todayHighlight': true, 'pickLevel': 2
                });
            })

            // ajeita defeito em butões
            const dtpicker = document.querySelectorAll(".datepicker-controls");
            [...dtpicker].map(Elem => {
                [...Elem.childNodes].map(El => {
                    El.classList.remove("button");
                    El.classList.add("btn");
                });
            })
        } catch (e) {
            console.error(e);
        }

    }

    RunDates();

    /**
     * @param {int} value Valor a ser alterado.
     * @return {string}
     * Função que mascara o dinheiro.
     */
    function moneyMask(value) {
        value = value.replace('.', '').replace(',', '').replace(/\D/g, '')

        const options = { minimumFractionDigits: 2 }

        const result = value != 0 ? new Intl.NumberFormat('pt-BR', options).format(
            parseFloat(value) / 100
        ) : '';

        return result != 'NaN' ? result : '';
    }

    /**
     * Run the function money on class money
     */
    function runMoney() {
        if (document.querySelector('.money')) {
            [...document.querySelectorAll('.money')].map(element => {
                element.addEventListener('keyup', _ => element.value = moneyMask(element.value))
            })
        }
    }

    runMoney();

    // tom select
    let allTSelects = document.querySelectorAll(".tselect"), objectSelect = {
        persist: false,
        createOnBlur: false,
        allowEmptyOption: true,
        create: false,
        maxOptions: 500,
        render: {
            no_results: () => `<div class="no-results">
                Nenhum resultado foi encontrado. <i class="ms-1 bi bi-emoji-frown"></i>
            </div>`
        }
    };

    let allTSelectsObjects = Array.from(allTSelects).map(el => ({ 
        element: el,
        tElement: new Tselect(el, objectSelect)
    }));

    let addTSelect = document.querySelectorAll(".add_tselect");

    objectSelect.create = (input) => {
        if (input.match(/(\d+)(?=\s-\s\D+)/))
            return { value: input, text: input };
        Toastr.error('Por favor siga o padrao: "{numero} - {texto}"');
        return false;
    };

    objectSelect.render = {
        no_results: (data, escape) => `<div class="no-results">
            O item ${escape(data.input)} nao existe. <i class="ms-1 bi bi-emoji-frown"></i>
        </div>`
    }

    allTSelectsObjects = [
        ...allTSelectsObjects,
        ...Array.from(addTSelect).map(el => ({
                element: el,
                tElement: new Tselect(el, objectSelect)
            }))
    ];

    Validator.useLang('pt');

    Viewer.noConflict();

    const linksToCopy = document.querySelectorAll('.copy-link');

    for (const link of linksToCopy) {
        link.onclick = function () {
            return copyLink(this)
        };
    }

    function copyLink(element) {
        const content = element.parentNode.parentNode.parentNode.parentNode.children[0].children[0].children[0].children[0]
        try {
            navigator.clipboard.writeText(content.value)
                .then(() => {
                    Toastr.success('Conteúdo copiado!');
                }, () => {
                    Toastr.error('Não foi possível copiar o conteúdo');
                })
        } catch (e) {
            Toastr.error('Não foi possível copiar o conteúdo');
        }
    }


    if (document.getElementById('startShow')) {
        const startshowModal = new bootstrap.Modal(document.getElementById('startShow'))
        startshowModal.show();
    }

    function isRequired(classe = "isRequired") {
        let isRequired = document.querySelectorAll("." + classe), valid = true;
        isRequired.forEach(value => {
            if (value.tagName === "SELECT" && value.classList.contains("tselect")) {
                let tsEl = value.nextElementSibling.firstChild;
                tsEl.style.borderColor = "#d0d0d0";
                if (value.value === "") {
                    tsEl.style.borderColor = "red";
                    valid = false;
                }
            } else {
                let val = value?.value;
                if (Array.from(value.classList).filter((raw) => raw === "phone").length > 0) {
                    val = value?.value.replaceAll(/[^0-8]/ig, "");
                }
                removeRequiredClass(value, invalidClass)
                if (value.type === "checkbox" && value.checked === false) {
                    addRequiredClass(value, invalidClass)
                    valid = false;
                } else if (val === "") {
                    addRequiredClass(value, invalidClass)
                    valid = false;
                }
            }
        })
        return valid;
    }

    function validarCPF(cpf) {
        cpf = cpf.replace(/[^\d]+/g, '');
        if (cpf === '') {
            return false;
        }
        // Elimina CPFs invalidos conhecidos
        if (
            cpf.length !== 11 ||
            cpf === "00000000000" ||
            cpf === "11111111111" ||
            cpf === "22222222222" ||
            cpf === "33333333333" ||
            cpf === "44444444444" ||
            cpf === "55555555555" ||
            cpf === "66666666666" ||
            cpf === "77777777777" ||
            cpf === "88888888888" ||
            cpf === "99999999999"
        ) {
            return false;
        }
        // Valida 1o digito
        let add = 0,
            rev;
        for (let i = 0; i < 9; i++) {
            add += parseInt(cpf.charAt(i)) * (10 - i);
        }
        rev = 11 - (add % 11);
        if (rev === 10 || rev === 11) {
            rev = 0;
        }
        if (rev !== parseInt(cpf.charAt(9))) {
            return false;
        }
        // Valida 2o digito
        add = 0;
        for (let i = 0; i < 10; i++) {
            add += parseInt(cpf.charAt(i)) * (11 - i);
        }
        rev = 11 - (add % 11);
        if (rev === 10 || rev === 11) {
            rev = 0;
        }
        if (rev !== parseInt(cpf.charAt(10))) {
            return false;
        }
        return true;
    }

    /**
     * @param {string|number} $cnpj
     * @return bool
     */
    function validarCnpj(cnpj) {
        cnpj = cnpj.replace(/[^\d]+/g, '');

        if (cnpj == '') return false;

        if (cnpj.length != 14)
            return false;

        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" ||
            cnpj == "11111111111111" ||
            cnpj == "22222222222222" ||
            cnpj == "33333333333333" ||
            cnpj == "44444444444444" ||
            cnpj == "55555555555555" ||
            cnpj == "66666666666666" ||
            cnpj == "77777777777777" ||
            cnpj == "88888888888888" ||
            cnpj == "99999999999999")
            return false;

        // Valida DVs
        let tamanho = cnpj.length - 2
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros[tamanho - i] * pos--;
            if (pos < 2)
                pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos[0])
            return false;

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros[tamanho - i] * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos[1])
            return false;

        return true;
    }

    function maiorIdade(dataNasc) {
        let dataAtual = new Date(),
            anoAtual = dataAtual.getFullYear(),
            diaAtual = dataAtual.getDate(),
            mesAtual = dataAtual.getMonth() + 1,
            anoNascParts = dataNasc.split('/'),
            diaNasc = anoNascParts[0],
            mesNasc = anoNascParts[1],
            anoNasc = anoNascParts[2],
            idade = anoAtual - anoNasc;

        //Se mes atual for menor que o nascimento, nao fez aniversario ainda;
        if (mesAtual < mesNasc) {
            idade--;
        } else {
            //Se estiver no mes do nascimento, verificar o dia
            if (mesAtual === mesNasc && diaAtual < diaNasc) {
                //Se a data atual for menor que o dia de nascimento ele ainda nao fez aniversario
                idade--;
            }
        }

        return idade >= 18;
    }

    function cpfToBorderRed(cp, fieldDate = null, requiredClass = null) {
        cp.onchange = ({ target }) => {
            const cpf = target.value;
            removeRequiredClass(cp, invalidClass)
            if (cpf !== "") {
                if (!validarCPF(cpf)) {
                    addRequiredClass(cp, invalidClass)
                    Toastr.error("Número de CPF inválido.")
                    return 0
                }
                return 1;
            } else if (fieldDate) {
                const datanascimento = fieldDate.value;
                if (datanascimento.value !== "") {
                    if (maiorIdade(datanascimento)) {
                        addRequiredClass(cp, invalidClass)
                        if (requiredClass) {
                            addRequiredClass(cp, requiredClass)
                        }
                        Toastr.error("Número de CPF é obrigatório.")
                        return 0;
                    }
                    removeRequiredClass(cp, invalidClass)
                    if (requiredClass) {
                        removeRequiredClass(cp, requiredClass)
                    }
                    return 1;
                }
            }
        }
    }

    function extractedClientSuspensoAutomatico(cp, id) {
        document.querySelector(`#${id}`).value = null;
        const cpf = cp.value;
        removeRequiredClass(cp, invalidClass)
        if (cpf === "") {
            addRequiredClass(cp, invalidClass)
            return 0
        }
        if (!validarCPF(cpf)) {
            addRequiredClass(cp, invalidClass)
            Toastr.error("Número de CPF inválido.")
            return 0
        }
        const xhr = fXhr({
            url: `/convidados/verifica-cpf/${cpf}`,
            method: 'GET'
        });
        xhr.onloadend = () => {
            const status = xhr.status;
            if (!(status >= 200 && status < 300)) {
                addRequiredClass(cp, invalidClass);
                return 0;
            } else {
                document.querySelector(`#${id}`).value = 1;
                return 1;
            }
        };
    }

    function isClientSuspensoAutomatico(cp, id) {
        const map = {
            tag: "input",
            parameter: { key: "type", value: "hidden" },
            id: id,
            value: null
        }
        let element = "";
        try {
            element = document.querySelector(`#${id}`);
            if (typeof (element) === undefined || element === '' || element == null) {
                element = create_element(map)
            }
        } catch (e) {
            element = create_element(map)
        }
        cp.after(element);
        return document.querySelector(`#${id}`).value = 1 // lembrar de voltar
        cp.onfocus = () => {
            document.querySelector(`#${id}`).value = null
        };
        cp.onclick = () => {
            document.querySelector(`#${id}`).value = null
        };
        cp.onchange = ({ target }) => {
            extractedClientSuspensoAutomatico(cp, id)
        }
    }

    function cnpjToBorderRed(cp) {
        cp.onchange = ({ target }) => {
            const cnpj = target.value;
            removeRequiredClass(cp, invalidClass)
            if (cnpj !== "") {
                if (!validarCnpj(cnpj)) {
                    addRequiredClass(cp, invalidClass)
                    Toastr.error("Número de CNPJ inválido.")
                    return 0
                }
                return 1;
            }
            return 0;
        }
    }

    function dateRequireCpf(fieldDate, cpfField, requiredClass = null) {
        fieldDate.addEventListener('changeDate', ({ target }) => {
            const datanascimento = target.value;
            if (cpfField.value === "") {
                if (maiorIdade(datanascimento)) {
                    addRequiredClass(cpfField, invalidClass)
                    if (requiredClass) {
                        addRequiredClass(cpfField, requiredClass)
                    }
                    Toastr.error("Número de CPF é obrigatório.")
                    return 0;
                } else {
                    removeRequiredClass(cpfField, invalidClass)
                    if (requiredClass) {
                        removeRequiredClass(cpfField, requiredClass)
                    }
                    return 1;
                }
            }
        })
    }

    function getFullAddressViaCep(cep, fieldBairro, fieldRua, fieldCidade, fieldEstado, fieldCep, fielAddressJson, form = null) {
        if (cep === "") {
            Toastr.error("Insira um CEP.");
            return 0;
        }
        const onlynumbers = cep.replace(/[^0-9]+/g, ""),
            xhr = fXhr({ url: `/get-info-address/${onlynumbers}`, method: 'GET' });
        try {
            fieldBairro.value = "...";
            fieldRua.value = "...";
            fieldCidade.value = "...";
            fieldEstado.value = "...";
            xhr.onload = () => {
                let result = JSON.parse(xhr.responseText);
                fieldBairro.value = result?.bairro;
                fieldRua.value = result?.logradouro;
                fieldCidade.value = result?.localidade;
                fieldEstado.value = result?.uf;
                fielAddressJson.value = result?.addressJson;
                if (result.erro) {
                    addRequiredClass(fieldCep, invalidClass);
                    addRequiredClass(fieldBairro, invalidClass);
                    addRequiredClass(fieldRua, invalidClass);
                    addRequiredClass(fieldCidade, invalidClass);
                    addRequiredClass(fieldEstado, invalidClass);
                } else {
                    removeRequiredClass(fieldCep, invalidClass);
                    removeRequiredClass(fieldBairro, invalidClass);
                    removeRequiredClass(fieldRua, invalidClass);
                    removeRequiredClass(fieldCidade, invalidClass);
                    removeRequiredClass(fieldEstado, invalidClass);
                }
                if(form){
                    form.dispatchEvent(new Event('change'));
                }
            }
            return 1;
        } catch (e) {
            Toastr.error("Não possível buscar dados de localização");
            return 0;
        }
    }

    function removeRequiredClass(variavel, requiredClass) {
        variavel.classList.contains(requiredClass) ? variavel.classList.remove(requiredClass) : 0;
    }

    function addRequiredClass(variavel, requiredClass) {
        !variavel.classList.contains(requiredClass) ? variavel.classList.add(requiredClass) : 0;
    }

    function loadingBtn(el) {
        el.setAttribute("style",
            "display: flex; justify-content: space-around; align-items: center; gap: 0.225rem;font-size: 12px;min-height: 1.2rem;")
        const loadingStatus = `
              <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Carregando...`
        el.setAttribute("disabled", "")
        el.innerHTML = loadingStatus;
    }

    function loadedBtn(el, text) {
        el.setAttribute("style", "");
        el.removeAttribute("disabled");
        el.innerHTML = text;
    }

    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            actions: 'flex justify-content-between gap-3',
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger'
        },
        buttonsStyling: false
    })

    function gridTemplate(columns, data) {
        return new Grid({
            columns,
            data,
            search: true,
            sort: true,
            pagination:
            {
                enabled: true,
                limit: 10,
                summary: false
            }
            , language: {
                'search':
                {
                    'placeholder':
                        '🔍 Pesquise...'
                },
                'pagination':
                {
                    'previous':
                        'Anterior',
                    'next':
                        'Próximo',
                    'showing':
                        'Mostrando',
                    navigate: (page, pages) => `Página ${page} de ${pages}`,
                    'results': () => 'Clientes',
                    of: 'de',
                    to: 'para',
                },
                loading: 'Carregando...',
                noRecordsFound: 'Nenhum resultado encontrado',
            }
        }).render(document.getElementById("custom-table"));
    }

    function xhrGet(url) {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        return xhr;
    }

    function xhrPost(url) {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", url);

        xhr.onreadystatechange = () => {
            // In local files, status is 0 upon success in Mozilla Firefox
            if (xhr.readyState === XMLHttpRequest.DONE) {
                const status = xhr.status, response = JSON.parse(xhr.responseText);
                if (status !== 0 || !(status >= 200 && status < 400)) {
                    // The request has been completed successfully
                    if (response?.errors) {
                        Toastr.error(Object.values(response.errors)[0]);
                    }
                }
            }
        };

        xhr.setRequestHeader("X-CSRF-TOKEN", document.querySelector("[name=_token]").value)
        xhr.setRequestHeader("accept", "application/json");
        return xhr;
    }

    function fXhr({ url, method, data, header, justSend = true }) {
        const xhr = new XMLHttpRequest(),
            form = new FormData();

        if (data) data = Object.entries(data);
        if (header) header = Object.entries(header);

        if (method.trim().replace(" ", "").toLowerCase() === "delete" ||
            method.trim().replace(" ", "").toLowerCase() === "put") {
            url += `?_method=${method}`;
            method = 'post';
        }

        xhr.open(method, url);

        xhr.onreadystatechange = () => {
            // In local files, status is 0 upon success in Mozilla Firefox
            if (xhr?.readyState === XMLHttpRequest?.DONE) {
                const status = xhr?.status;
                let response
                try {
                    response = JSON?.parse(xhr?.responseText);
                } catch (e) { }
                if (response && status !== 0 || !(status >= 200 && status < 400)) {
                    // The request has been completed successfully
                    if (response?.errors) {
                        Toastr.error(Object.values(response?.errors)[0]);
                    }
                }
            }
        };

        if (data && data.length > 0) data.forEach((dt) => form.append(dt[0], dt[1]));
        if (header && header.length > 0) header.forEach((hd) => xhr.setRequestHeader(hd[0], hd[1]));
        xhr.setRequestHeader("X-CSRF-TOKEN", document.querySelector("[name=_token]").value)
        xhr.setRequestHeader("accept", "application/json");
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest")
        const cleanMethod = method.trim().replace(" ", "").toLowerCase();
        if(justSend){
            if (cleanMethod === "post"){
                xhr?.send(form);
                return xhr;
            } 
            xhr?.send();
        }
        return xhr;
    }

    function fXhrTwo({ url, method, data, header }) {
        const xhr = new XMLHttpRequest();

        if (header) header = Object.entries(header);

        if (method.trim().replace(" ", "").toLowerCase() === "delete" ||
            method.trim().replace(" ", "").toLowerCase() === "put") {
            url += `?_method=${method}`;
            method = 'post';
        }

        xhr.open(method, url);

        xhr.onreadystatechange = () => {
            // In local files, status is 0 upon success in Mozilla Firefox
            if (xhr.readyState === XMLHttpRequest.DONE) {
                const status = xhr.status, response = JSON.parse(xhr.responseText);
                if (status !== 0 || !(status >= 200 && status < 400)) {
                    // The request has been completed successfully
                    if (response?.errors) {
                        Toastr.error(Object.values(response.errors)[0]);
                    }
                }
            }
        };

        if (header && header.length > 0) header.forEach((hd) => xhr.setRequestHeader(hd[0], hd[1]));
        const form = JSON.stringify(data);
        xhr.setRequestHeader("X-CSRF-TOKEN", document.querySelector("[name=_token]").value)
        xhr.setRequestHeader("Accept", "application/json");
        xhr.setRequestHeader("Content-Type", "application/json");
        if (method.trim().replace(" ", "").toLowerCase() === "post") xhr.send(form);
        else xhr.send();
        return xhr;
    }

    /**
     * @param {string} url URL da requisição com ou sem parametro.
     * @param {string} type Tipo da requisição: GET, PUT, POST E DELETE.
     * @param {object} data Objeto a ser enviado.
     * @return {string}
     * Função que faz requisição para o backend.
     */
    async function eFetch(url, type = 'GET', data = null) {
        try {
            let response;
            if (type === 'GET') {
                response = await fetch(url);
            } else {
                response = await fetch(url, {
                    headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json, text-plain, */*",
                        "X-Requested-With": "XMLHttpRequest",
                        "X-CSRF-TOKEN": document.querySelector("[name=_token]").value
                    },
                    method: type,
                    body: data ? JSON.stringify(data) : '',
                });
            }
            let result = await response.json();
            if (response.status !== 200 && result?.errors) {
                let frase = Object.values(result.errors)[0];
                if (Array.isArray(frase)) {
                    Toastr.error(frase?.[0]);
                } else {
                    Toastr.error(frase);
                }
            }
            return result;
        } catch (err) {
            console.log(`Erro: ${err.message}\nRequisição: ${url}\nData: ${data ? data : 'Sem Dados enviados'}\nTipo: ${type}`);
        }
    }

    /**
     * @param {{tag: string, id: any, classes: string, estilos: string, conteudo: string, value: any, parameter: {key:string, value:string}}} object
     * @return {Element}
     * Função responsavel por criar e retornar um elemento HTML.
     */
    function create_element({ tag, id, classes, estilos, conteudo, value, parameter, onclick }) {

        if (!tag) return null;
        let element = document.createElement(tag);

        if (id) element.setAttribute('id', id);
        if (classes) element.setAttribute('class', classes);
        if (estilos) element.setAttribute('style', estilos);
        if (conteudo) element.innerHTML = conteudo;
        if (value) element.setAttribute('value', value);
        if (parameter) {
            if(Array.isArray(parameter) && parameter.length > 0){
                for (const param of parameter) {
                    if(param?.key && param?.value){
                        element.setAttribute(param.key, param.value);
                    }
                }
            }else if(parameter?.key && parameter?.value){
                element.setAttribute(parameter.key, parameter.value);
            }
        }
        if(onclick) element.onclick = onclick;

        return element;
    }

    function debounce(fn, delay) {
        let timeout = null;

        return function(...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => fn.apply(context, args), delay);
        };
    }

    async function wait(time) {
        await new Promise(r => setTimeout(r, time))
    }

    const allCpfs = document.querySelectorAll('.cpf');
    for (const cpf of allCpfs) {
        cpfToBorderRed(cpf);
    }

    const clearIfEmailIsSeller = () => {
        
        const email = document.querySelector('#email');
        email.onchange = () => {
            const xhr = fXhr({
                url: '/validar-email',
                method: 'POST',
                data: {email: email.value}
            });
            xhr.onloadend = () => {
                // Success
                if (xhr.readyState === 4 && xhr.status === 200) {
                    const response = JSON.parse(xhr.responseText);
                    if (response.status)
                        return;
                    email.value = "";
                    if (loggedIn) {
                        Toastr.error("Endereço de e-mail indisponível para uso no sistema.");
                    } else {
                        Toastr.error("E-mail inválido");
                    }
                    return;
                }
                email.value = "";
                Toastr.error("Falha na validação do e-mail, tente novamente");
            }
        }
    }

    const clearTomSelect = (instance) => {
        instance.clearOptions();
        instance.clear();
        instance.clearCache();
        instance.removeItem(instance.getValue(), true)
        instance.setValue("");
        instance.clearOptions();
        instance.clear();
        instance.clearCache();
        instance.removeItem(instance.getValue(), true)
    }

    // Global definition
    window.bootstrap = bootstrap;
    window.IMask = IMask;
    window.Toastr = Toastr;
    window.Tselect = Tselect;
    window.allTSelectsObjects = allTSelectsObjects;
    window.Swal = Swal;
    window.Grid = Grid;
    window.RowSelection = RowSelection;
    window.h = h;
    window.Validator = Validator;
    window.copyLink = copyLink;
    window.isRequired = isRequired;
    window.validarCPF = validarCPF;
    window.validarCnpj = validarCnpj;
    window.maiorIdade = maiorIdade;
    window.cpfToBorderRed = cpfToBorderRed;
    window.cnpjToBorderRed = cnpjToBorderRed;
    window.dateRequireCpf = dateRequireCpf;
    window.getFullAddressViaCep = getFullAddressViaCep;
    window.removeRequiredClass = removeRequiredClass;
    window.addRequiredClass = addRequiredClass;
    window.loadingBtn = loadingBtn;
    window.loadedBtn = loadedBtn;
    window.invalidClass = invalidClass;
    window.swalWithBootstrapButtons = swalWithBootstrapButtons;
    window.viewer = Viewer;
    window.gridTemplate = gridTemplate;
    window.xhrGet = xhrGet;
    window.xhrPost = xhrPost;
    window.fXhr = fXhr;
    window.fXhrTwo = fXhrTwo;
    window.eFetch = eFetch;
    window.create_element = create_element;
    window.moneyMask = moneyMask;
    window.runMoney = runMoney;
    window.isClientSuspensoAutomatico = isClientSuspensoAutomatico;
    window.debounce = debounce;
    window.RunDates = RunDates;
    window.wait = wait;
    window.generateMask = generateMask;
    window.clearIfEmailIsSeller = clearIfEmailIsSeller;
    window.clearTomSelect = clearTomSelect;
} catch (e) {

}
